// extracted by mini-css-extract-plugin
export var notificationHost = "_jw-0";